/**
 * Device export column configuration (headers must match backend registry).
 */

export const DEVICE_EXPORT_COLUMN_HEADERS = [
  'Device ID',
  'Device Name',
  'Device Category',
  'Criticality',
  'Model',
  'Serial Number',
  'Year of Manufacture',
  'Manufacturer',
  'Supplier',
  'Physical Location',
  'Location Name',
  'Location Code',
  'Department',
  'Custodian Name',
  'Installation Date',
  'Purchase Date',
  'Product Cost',
  'Device Status',
  'Notes',
  'Created At',
  'Updated At',
  'Warranty Period',
  'Warranty Expiry',
  'Service Contract Type',
  'Service Contract Period',
  'Service Contract Cost',
  'Contract Start Date',
  'Contract Expiry',
  'PPM Frequency',
  'PPM Last Done Date',
  'PPM Next Due Date',
  'Calibration Required',
  'Calibration Frequency',
  'Calibration Last Done Date',
  'Calibration Next Due Date',
  'Compliance Required',
  'Compliance Type',
  'Compliance Frequency',
  'Compliance Last Done Date',
  'Compliance Next Due Date',
  'Active Complaint Count',
  'Device Age',
  'PPM Status',
  'Calibration Status',
  'Compliance Status',
  'Warranty Status',
  'Contract Status',
  'Coverage Status',
  'Document Count',
  'Active Alert Count',
];

/** Shared defaults for Excel + PDF (≤ PDF_EXPORT_MAX_COLUMNS). UI uses this single set. */
export const DEVICE_EXPORT_EXCEL_DEFAULT_HEADERS = new Set([
  'Device ID',
  'Device Name',
  'Criticality',
  'Model',
  'Serial Number',
  'Department',
  'Location Name',
  'Device Status',
  'PPM Status',
  'Coverage Status',
]);

/** Keep in sync with DEVICE_EXPORT_EXCEL_DEFAULT_HEADERS (shared picker). */
export const DEVICE_EXPORT_PDF_DEFAULT_HEADERS = new Set([
  ...DEVICE_EXPORT_EXCEL_DEFAULT_HEADERS,
]);

export const createDeviceExportColumnsState = (format = 'excel') => {
  const defaults =
    format === 'pdf' ? DEVICE_EXPORT_PDF_DEFAULT_HEADERS : DEVICE_EXPORT_EXCEL_DEFAULT_HEADERS;
  return DEVICE_EXPORT_COLUMN_HEADERS.reduce((acc, header) => {
    acc[header] = defaults.has(header);
    return acc;
  }, {});
};

export const getSelectedExportColumnHeaders = (exportColumns) =>
  Object.entries(exportColumns)
    .filter(([, enabled]) => enabled !== false)
    .map(([header]) => header);
